<ng-container *ngIf="betslip; else error">
    <ms-my-bets-betslip [betslip]="betslip" [myBetsListContext]="myBetsListContext" [isLast]="false"> </ms-my-bets-betslip>
</ng-container>
<ng-template #error>
    <div class="message-panel">
        <vn-icon name="theme-error-i" size="16" />
        <div class="cms-container">
            <span>{{ sitecoreMyBets.myBets.NoBetsALL }}</span>
        </div>
    </div>
</ng-template>
